// extracted by mini-css-extract-plugin
export default {"radioLabel":"RadioButtonV2_radioLabel__e0Y05","large":"RadioButtonV2_large__aHqDb"};